/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the maintenance module.
────────────────────────────────────────────────────────────────*/


import { api } from '@/lib/api';

export interface CronProfile {
    id: number;
    uuid: string;
    tenantId: number;
    name: string;
    schedule: string;
    enabled: boolean;
    lastRun?: string;
    createdAt: string;
    updatedAt?: string;
}

export interface CronProfileCreatePayload {
    name: string;
    schedule: string;
    enabled?: boolean;
}

export interface CronProfileUpdatePayload {
    name?: string;
    schedule?: string;
    enabled?: boolean;
}

const BASE_URL = '/api/telephony/cron-profiles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCronProfiles = async (params?: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data } = await api.get<{ data: CronProfile[]; pagination: any }>(BASE_URL, { params });
    return data;
};

export const getCronProfile = async (id: number | string) => {
    const { data } = await api.get<CronProfile>(`${BASE_URL}/${id}`);
    return data;
};

export const createCronProfile = async (payload: CronProfileCreatePayload) => {
    const { data } = await api.post<CronProfile>(BASE_URL, payload);
    return data;
};

export const updateCronProfile = async (id: number | string, payload: CronProfileUpdatePayload) => {
    const { data } = await api.put<CronProfile>(`${BASE_URL}/${id}`, payload);
    return data;
};

export const deleteCronProfile = async (id: number | string) => {
    const { data } = await api.delete<{ success: boolean }>(`${BASE_URL}/${id}`);
    return data;
};
